import { ApplicationRef, Directive, HostListener, inject } from '@angular/core';

/**
 * Lets an ngbTooltip finish opening inside the routed screens.
 *
 * ng-bootstrap creates the tooltip window straight away but only adds its `show` class - the one
 * that takes it from opacity 0 to visible - from an afterNextRender hook tied to the host's view.
 * The routed screens live under the downgraded AppComponent, whose views are refreshed by the
 * AngularJS digest, not by ApplicationRef.tick. In one turn the tick runs first and the digest
 * second, so the digest is what files the hook and only a later tick would run it - and nothing
 * schedules one. The window sat in the page at opacity 0 (SB-16568, and the Sports Portal settings
 * info icon before it). Asking for one more tick after the turn that opened the tooltip runs the
 * hook and the fade-in completes.
 *
 * Applied by selector to every `[ngbTooltip]` in a module that imports SharedModule.
 */
@Directive({
  // It has to match ng-bootstrap's own attribute to reach every existing tooltip unchanged.
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ngbTooltip]',
  standalone: true
})
export class NgbTooltipRefreshDirective {
  private readonly applicationRef = inject(ApplicationRef);

  @HostListener('mouseenter')
  @HostListener('focusin')
  @HostListener('click')
  onTrigger(): void {
    setTimeout(() => this.applicationRef.tick());
  }
}
